import { useEffect } from 'react';
import { ITEMS } from 'consts/localStorage';

const useAuthorizationListener = () => {
  useEffect(() => {
    const handleStorageChange = event => {
      // If the token is changed, added or removed, then the session has been modified
      // The page is reloaded to handle this
      if (event.key === ITEMS.token) {
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};

export default useAuthorizationListener;
